// extracted by mini-css-extract-plugin
module.exports = {"main":"breadcrumbs_main__VBByA","crumbs":"breadcrumbs_crumbs__pJ96J","crumb":"breadcrumbs_crumb__NOO8e","phAnimation":"breadcrumbs_phAnimation__MNg6t"};